import { createApp, watch, nextTick } from "vue";
import { createPinia } from "pinia";
import { useFeedStore } from "@facet/utils/store.js";
import { TAXONOMIES } from "@facet/utils/constants";
import App from "./App.vue";

const app = createApp(App);
app.use(createPinia());
app.mount("#app");

const store = useFeedStore();

await nextTick();

// Read filters from URL params and apply to store before fetching
function readFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    TAXONOMIES.forEach(({ key }) => {
        const value = params.get(key);
        if (value) {
            store.filters[key] = value.split(",").map(Number).filter(Boolean);
        }
    });
}

// Sync active filters back to the URL
function writeFiltersToURL() {
    const params = new URLSearchParams(window.location.search);
    TAXONOMIES.forEach(({ key }) => {
        const values = store.filters[key];
        if (values && values.length > 0) {
            params.set(key, values.join(","));
        } else {
            params.delete(key);
        }
    });
    const newSearch = params.toString();
    const newURL = newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname;
    history.replaceState(null, "", newURL);
}

readFiltersFromURL();
store.fetchItems();

watch(
    () => store.filters,
    () => {
        store.applyFilters();
        writeFiltersToURL();
    },
    { deep: true },
);

// watch(() => store.month, async () => {
//     await store.fetchItems()
// })
